export const environment = {
  env: 'staging',
  enableProdMode: false,
  baseUrl: 'https://order-history.ui.stage.ngin-staging.com',
  mySeUrl: 'https://my.stage.ngin-staging.com',
  apiUrl: 'https://api.stage.ngin-staging.com',
  production: false,
  clientId: 'fb703f8d7cbfe0cb44d1fcee1c683274',
  domainSpecificUrls: [
    {
      default: true,
      domain: 'https://order-history.ui.stage.ngin-staging.com',
      api: 'https://api.stage.ngin-staging.com',
      user: 'https://user.stage.ngin-staging.com',
      urls: {
        api: 'https://api.stage.ngin-staging.com',
      },
    },
  ],
};
